module.exports = __webpack_public_path__ + "static/media/vegitables_1.8488e96f.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_1.csv
// module id = 591
// module chunks = 0